import Drawer from "@mui/material/Drawer";
import { voidFuncType } from "../../../features/types/features.types";
type CustomDrawerType = {
  children: React.ReactNode;
  open: boolean;
  drawerHandler: voidFuncType;
};
const CustomDrawer = ({ children, open, drawerHandler }: CustomDrawerType) => {
  return (
    <Drawer anchor={"left"} open={open} onClose={() => drawerHandler()}>
      {children}
    </Drawer>
  );
};
export default CustomDrawer;
